export const locales = {
    "no": {
        "header": "Rediger ressurser",
        "add": "Ny",
        "form-close": "Lukk",
        "form-type": "Ressurstype",
        "form-type-vm": "Server",
        "form-type-vmss": "Nodesett",
        "form-id": "Id",
        "form-name": "Navn",
        "form-description": "Beskrivelse",
        "form-resourceGroup": "Ressursgruppe",
        "form-save": "Lagre",
        "list-header-name": "Navn",
        "list-header-description": "Beskrivelse",
        "list-header-edit": "Rediger"
    }
};